import React from 'react';
import './PC.css';
import AccentureSong from '../../img/pc/AccentureSong.png'
import Guan from '../../img/pc/Guan.png'
import Hogan from '../../img/pc/Hogan.png'
import Kozanoglu from '../../img/pc/Kozanoglu.png'
import Lewis from '../../img/pc/Lewis.png'
import NodeSource from '../../img/pc/NodeSource.png'
import PathUnbound from '../../img/pc/PathUnbound.png'
import Schuster from '../../img/pc/Schuster.png'
import Shopify from '../../img/pc/Shopify.png'
import truematter from '../../img/pc/truematter.png'
import Villa from '../../img/pc/Villa.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Hogan,
          name: 'Stephy Hogan',
          position: 'Associate UX Director @IBM',
          ln: 'https://www.linkedin.com/in/stephyhogan/',
          tw: 'https://twitter.com/stephyhogan',
        },
        {
          photo: Lewis,
          name: 'Molly Lewis',
          position: 'Senior Product Designer',
          ln: 'https://www.linkedin.com/in/molly-lewis-9013a1108/',
          logo: AccentureSong,
        },
        {
          photo: Schuster,
          name: 'Dean Schuster',
          position: 'Partner, owner',
          ln: 'https://www.linkedin.com/in/dean-schuster/',
          tw: 'https://twitter.com/experiencedean',
          logo: truematter,
        },
        {
          photo: Villa,
          name: 'Marian Villa',
          position: 'Sr Fullstack product Designer',
          ln: 'https://www.linkedin.com/in/marianvilla/',
          tw: 'https://twitter.com/Marianvilla',
          github: 'https://github.com/marianvilla',
          logo: NodeSource,
        },
        {
          photo: Guan,
          name: 'Stella Guan',
          position: 'Visual Designer, Founder',
          inst: 'https://www.instagram.com/stella.guan/',
          ln: 'https://www.linkedin.com/in/stellaguan',
          logo: PathUnbound,
        },
        {
          photo: Kozanoglu,
          name: 'Berjesty Kozanoglu',
          position: 'UX Manager',
          ln: 'https://www.linkedin.com/in/bercestekozanoglu',
          inst: 'https://www.instagram.com/ux.faculty/?hl=en',
          logo: Shopify,
        },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous events</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}